/**
 *  @function addIdToRecentlyViewed
 */

if (window.localStorage) {
  if (!window.localStorage.getItem('recently-viewed')) {
    window.localStorage.setItem('recently-viewed', JSON.stringify([]));
  }
}

function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector('.product');
    if (product) {
      handle = product.dataset.handle;

      if (!handle) {
        return;
      }
    }
  }

  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof recentIds !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }

  // Remove current product if already in recently viewed array
  window.recentlyViewedIds = window.recentlyViewedIds.filter((i) => i != handle);

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}
